import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import classnames from 'classnames';
import Image from 'next/image';
import React, { useCallback } from 'react';
import styles from './modal-confirmation.module.scss';
import { Modal } from '../modal/modal';
import { Button } from '../../button';
import { Icon } from '../../icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ModalConfirmation = function ModalConfirmation(_ref) {
  var _classnames;

  var isOpen = _ref.isOpen,
      title = _ref.title,
      info = _ref.info,
      disclaimer = _ref.disclaimer,
      image = _ref.image,
      showBackground = _ref.showBackground,
      badge = _ref.badge,
      danger = _ref.danger,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$loadingLabel = _ref.loadingLabel,
      loadingLabel = _ref$loadingLabel === void 0 ? 'Loading' : _ref$loadingLabel,
      confirmIcon = _ref.confirmIcon,
      confirmLabel = _ref.confirmLabel,
      cancelLabel = _ref.cancelLabel,
      onConfirm = _ref.onConfirm,
      onDismiss = _ref.onDismiss,
      onClose = _ref.onClose,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
      _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
      shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? true : _ref$shouldCloseOnOve;
  var handleDismiss = useCallback(function () {
    if (!loading) onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
  }, [loading, onDismiss]);
  return /*#__PURE__*/_jsx(Modal, {
    targetId: "moises-app",
    label: title,
    isOpen: isOpen || false,
    onClose: onClose || handleDismiss,
    showCloseButton: showCloseButton,
    modalClassName: styles.modal,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick && !loading,
    children: /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.content, (_classnames = {}, _defineProperty(_classnames, styles.background, showBackground), _defineProperty(_classnames, styles.withoutCloseButton, !showCloseButton), _classnames)),
      children: [badge && /*#__PURE__*/_jsx("div", {
        className: styles.badge,
        children: badge
      }), image && /*#__PURE__*/_jsx(Image, {
        alt: "",
        className: styles.image,
        src: "/assets/images/".concat(image, ".svg"),
        width: showBackground ? '80' : '100',
        height: showBackground ? '110' : '100',
        style: {
          top: showBackground ? '' : '-10px'
        }
      }), /*#__PURE__*/_jsx("p", {
        className: styles.title,
        children: title === null || title === void 0 ? void 0 : title.replace(/\*{2}(.*?)\*{2}/g, '$1')
      }), info && /*#__PURE__*/_jsx("p", {
        className: styles.info,
        children: info
      }), disclaimer ? /*#__PURE__*/_jsx("p", {
        className: styles.disclaimer,
        children: disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.replace(/\*{2}(.*?)\*{2}/g, '$1')
      }) : null, /*#__PURE__*/_jsxs("div", {
        className: styles.actions,
        children: [/*#__PURE__*/_jsx(Button, {
          small: true,
          danger: danger,
          radius: 1,
          disabled: loading,
          onClick: onConfirm,
          className: styles.button,
          id: "modal_button_confirm",
          title: loading ? loadingLabel : confirmLabel,
          icon: loading ? /*#__PURE__*/_jsx(Icon, {
            name: "loader",
            animation: "spin",
            width: 22,
            height: 22
          }) : confirmIcon ? /*#__PURE__*/_jsx(Icon, {
            name: confirmIcon,
            width: 22,
            height: 22
          }) : undefined
        }), cancelLabel && /*#__PURE__*/_jsx(Button, {
          small: true,
          light: true,
          stroke: true,
          radius: 1,
          transparent: true,
          disabled: loading,
          title: cancelLabel,
          id: "modal_button_dismiss",
          className: classnames(styles.cancel, styles.button),
          onClick: handleDismiss
        })]
      })]
    })
  });
};